import type { SportsPromotionState } from './types';

export const defaultState: SportsPromotionState = {
  isLoading: false,
  hasPreloaded: false,
  hasErrored: false
};
